/**
 * AC-BIN-098 の承認者判定に使う、 承認待ちの札が今待っている承認段階の承認者
 * member_id 一覧と、 現在ユーザーがそれに含まれるか。
 *
 * 承認者の一覧は一覧・詳細 RPC の `currentStageApproverMemberIds` をそのまま使う。 backend が
 * 承認の実処理と同じ「承認申請時に写した段」 から返すので、 申請後に承認フロー設定を
 * 変えても、 実際に承認できる人と警告の対象が食い違わない。
 *
 * この突合を frontend 側に持つのは本来 業務判断を backend に置く規約に抵触し、
 * spot 側 (AC-BSP-098) にも複製されるため shotgun surgery のリスクがある。
 * BFF read 集約への移設は #8349 で追跡 (ytnsym レビュー指摘、 PR #8083)。
 *
 * `isApprover` は fail-closed (= 判定できない時は「承認者でない」に倒す)。
 * `session_service.proto` の `member_id` フィールドコメントが明示する契約:
 * 「The frontend must still treat an absent value as "not an approver"
 * (fail-closed) rather than falling back to allowing the operation」 に従う
 * (`currentMemberId` が undefined = session RPC 未解決 / 失敗)。 呼び出し元は
 * セッションが読み込み中の間だけ警告表示を止め (未確定な判定を確定情報として出さない
 * ため)、 読み込みが終われば本関数の fail-closed な判定をそのまま表示する。
 */
export type IntradayApproverStatus = {
  /** 当該承認段階の承認者 member_id 一覧 (空配列 = 「承認者: 設定なし」)。 */
  approverMemberIds: readonly string[]
  /** 現在ユーザーが承認者に含まれるか (fail-closed)。 */
  isApprover: boolean
}

export function resolveIntradayApproverStatus(
  approverMemberIds: readonly string[],
  currentMemberId: string | undefined,
): IntradayApproverStatus {
  const isApprover =
    currentMemberId !== undefined && approverMemberIds.includes(currentMemberId)
  return { approverMemberIds, isApprover }
}
